/** API route map: URLS.Controller.CandidateSkill */
export const CandidateSkill = {
      Name: 'CandidateSkill/',
      GetSkills: 'get-candidate-skills',
      SearchSkills: 'search-skills',
      AddSkill: 'add-skill',
      UpdateSkill: 'update-skill',
      UpsertSkill: 'upsert-skills',
      GetCandidateSkills: 'all-candidate-skills',
};
